const ElementCreator = require('./abstract/element');
const ImageSetter = require('../setters/image');
const ImagesFactory = require('../../../factory/images');

module.exports = ImageCreator;

function ImageCreator () {}

ImageCreator.prototype = _.extend(new ElementCreator(), ImageSetter.prototype);
ImageCreator.prototype.constructor = ImageCreator;

ImageCreator.prototype.initialize = function () {
  ElementCreator.prototype.initialize.call(this);

  this.mandatory = ['source.url'];
  _.extend(this.defaults, {
    placeholder: true,
    smart_asset: null,
    source: {
      url: 'https://static.inkive.com/assets/img/placeholders/imageplaceholder_new.svg',
      smart_load: true,
      external_resize: false
    }
  });

  INKIVE.UserInfoFactory.getMembership().then(_.bind(function (userInfo) {
    this.canEditTemplate = userInfo?.permissions?.templates_update;
  }, this));

  this.isBrandTemplate = INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE;
};

ImageCreator.prototype.create = function (data) {
  const editorFacade = require('../../editor/editor');
  const isAdminEditingTemplate = this.canEditTemplate && this.isBrandTemplate;

  data.external = typeof data.source.external_resize === 'undefined'
    ? this.isExternal(data)
    : data.source.external_resize;

  const richData = this.getAddData(data);
  let element = this.canvas.addElement('image', richData);
  const id = element.getAttribute('id');

  editorFacade.once('image.rename.' + id, _.bind(function (data) {
    element = $('#' + data.id)[0];
    handleShutterstockThumb.call(this, data);
    onElementReady.call(this);
  }, this));

  editorFacade.handle(id, 'crop', {
    quiet: true, scale: 1
  });

  if (!isAdminEditingTemplate) {
    setRemovePlaceholderOnDelete();
  }

  richData.smart_asset && INKIVE.ImagesFactory.addBBoxValues(element);

  return element.getAttribute('id');

  function setRemovePlaceholderOnDelete () {
    element.classList.add('quick-delete');
  }

  function handleShutterstockThumb (elementId) {
    if (data.external_source !== INKIVE.C.SHUTTERSTOCK) return;

    $(element).css('opacity', 0);

    this.getDefinedData(data, 'external_source') && $(element).data('external_source', data.external_source);
    this.getDefinedData(data, 'external_id') && $(element).data('external_id', data.external_id);
    $(element).data('external_url', data.source.url);

    this.getShutterstockCropBox(data).then(_.bind(function (thumbSize) {
      const thumbData = _.clone(this.getAddData(data));

      thumbData.width = thumbSize.width;
      thumbData.height = thumbSize.height;

      const thumbElement = this.canvas.addElement('image', thumbData);
      const thumbId = $(thumbElement).attr('id');

      editorFacade.once('image.rename.' + thumbId, _.bind(function (thumbData) {
        $('#' + thumbData.id).data('external_source', INKIVE.C.SHUTTERSTOCK).addClass('non-selectable');
        this.processSstkProImage(data, thumbData, elementId, element);
      }, this));

      editorFacade.handle(thumbId, 'crop', {
        quiet: true,
        scale: 1,
        skip_selection: true,
        clip_path: this.getAddData(data)
      });
    }, this));
  }

  function onElementReady () {
    const elementId = element.getAttribute('id');

    if (data && data.external_source === INKIVE.C.SHUTTERSTOCK && data.subscription_image) return;

    if (data.external) {
      this.resizeExternalPhoto(element, data);
      this.trigger('', elementId);
    } else {
      if (data.source.base_64) {
        this.updateSourceBase64(element, data);
        this.once('source.base_64', _.partial(this.trigger, '', elementId));
      } else if (data.imported && !('ab_id' in data)) {
        this.trigger('source.url', elementId);
      } else {
        this.getDefinedData(data, 'source.smart_load') && this.onVersionData(element, data);
        this.once('source.url', _.partial(this.trigger, '', elementId));
      }
    }
  }
};

ImageCreator.prototype.onVersionData = function (element, data) {
  const isShutterstock = data?.external_source === INKIVE.C.SHUTTERSTOCK;
  if (!isShutterstock) {
    ImagesFactory.storeImageData(data.source.url);
  }

  ImageSetter.prototype.onVersionData.apply(this, arguments);
};

ImageCreator.prototype.getSize = function (element, data) {
  return {
    width: this.getDefinedData(data, 'size.width'),
    height: this.getDefinedData(data, 'size.height')
  };
};

ImageCreator.prototype.getAddData = function (data) {
  const getDefinedData = _.bind(this.getDefinedData, this, data);
  const source = getDefinedData('source.url');
  const thumbnail = data.imported ? source : (ImagesFactory.getVersionUrl(source, 'thumb') || source);

  return {
    url: thumbnail,
    x: getDefinedData('position.x'),
    y: getDefinedData('position.y'),
    width: getDefinedData('size.width'),
    height: getDefinedData('size.height'),
    smart_asset: data.smart_asset
  };
};

ImageCreator.prototype.processSstkProImage = function (data, thumbData, elementId, element) {
  const DesignFacade = require('../../../facade/design/design');

  DesignFacade.trigger('image.sstk_replace.start', elementId);

  data.subscription_image
    ? INKIVE.DesygnerApi.post('payment/gateway/stripe/process', data.subscription_image).then(function (processData) {
      if (processData.info) {
        DesignFacade.trigger('image.sstk_replace.start', elementId);
        processData.thumbId = thumbData.id;
        INKIVE.EditorFacade.handle('shopping_cart', 'on_payment', { elementId: element.id, ...processData });
      } else {
        finishProcessing();
      }
    })
    : DesignFacade.once('image.create.source.url', finishProcessing);

  function finishProcessing () {
    $(element).css('opacity', '');
    $('#' + thumbData.id).remove();
    svgedit.select.getSelectorManager().releaseAllSelectors();
  }
};

ImageCreator.prototype.getShutterstockCropBox = function (data) {
  const deferred = $.Deferred();
  const img = data.$elem && data.$elem.find('img')[0];
  const thumbSize = img && {
    width: img.naturalWidth,
    height: img.naturalHeight
  };

  if (!thumbSize || thumbSize.width === 0 || thumbSize.height === 0) {
    const image = new Image();

    image.onload = function () {
      calculateCropBox({
        width: this.naturalWidth,
        height: this.naturalHeight
      });
    };

    image.src = data.source.url;
  } else {
    calculateCropBox(thumbSize);
  }

  function calculateCropBox (thumbSize) {
    const size = data.size;
    const isWider = size.width > size.height;

    deferred.resolve({
      width: isWider ? size.width : size.height * thumbSize.width / thumbSize.height,
      height: isWider ? size.width * thumbSize.height / thumbSize.width : size.height
    });
  }

  return deferred.promise();
};
